<template>
  <section class="page">
    <add-chat v-if="getAddChat" />
    <chat-settings />
    <modal-add-user v-if="getInvite"/>
    <modal-party />
    <chat-list 
      :dialogs="chats" 
      :loader="loader_list"
      :loader_more="loader_more"
      />
    <chat-area v-if="$socket" />
    <modal-photos />
  </section>
</template>

<script>
import ChatList from './components/ChatList'
import ChatArea from './components/ChatArea'
export default {
  name: 'Chats',
  components: {
    ChatList,
    ChatArea,
    AddChat: () => import('./components/AddChat.vue'),
    ChatSettings: () => import('./components/ChatSettings'),
    ModalParty: () => import('./components/ModalChatParty.vue'),
    ModalPhotos:  () => import('@/components/Modals/ModalPhoto'),
    ModalAddUser: () => import('./components/ModalChatAddUser.vue'),
  },
  data() {
    return {
      chats: null,
      loader_list: true,
      loader_more: false
    }
  },
  computed: {
    getChats () {
      return this.$store.getters.getChats
    },
    getChatSearch () {
      return this.$store.getters.getChatSearch
    },
    getUser() {
      let user = this.$store.getters.getAuthUser;
      return user ? user.id : null
    },
    getInvite() {
      return this.$store.getters.invite
    },
    getAddChat () {
      return this.$store.getters.new_chat
    }
  },
  head: {
    
      meta: [
        { property: 'og:description', content: 'Happy for your contact', id: 'desc' }
      ],
      // link: [
      //   { rel: 'canonical', h: 'http://example.com/#!/contact/', id: 'canonical'}
      // ]
    },
  sockets: {
    addError({message}) {
      this.$store.dispatch('addError', {message})
    }
  },
  methods: {
    async loadData (options) {
      this.chats 
        ? this.loader_more = true 
        : this.loader_list = options.loader
      this.chats = await this.$store.dispatch('fetchChats', {user: this.getUser, search: this.getChatSearch})
      this.chats.length > 0 && this.getChatSearch.my && !this.getChatSearch.caption 
        ? localStorage.setItem('chats', JSON.stringify(this.chats))
        : ''
      this.loader_list = false
      this.loader_more = false
    },
    getLast() {
      this.chats = JSON.parse(localStorage.getItem('chats'));
    }
  },
  watch: {
    getChatSearch() {
      this.loadData({loader: true})
    },
  },
  mounted () {
    this.loadData({loader: true})
    setInterval(() => {
      this.$route.name == 'messages' || this.$route.name == 'chat' ? this.loadData({loader: true}) : '';
    }, 1000 * 5 * 60);
  },
  created () {
    this.getLast()
    this.$route.name === 'chat' ? this.$store.dispatch('changeState', {element: 'chat_list', val: true}) : ''
  }
}

</script>
